// extracted by mini-css-extract-plugin
module.exports = {"search-icon":"_4e5f713ae4--search-icon--VPt0G"};